import React, { useCallback, useMemo } from "react";
import { keepPreviousData, useQuery, useQueryClient } from '@tanstack/react-query';
import { getPromotionCampaign, getPromotionCampaigns } from "../../../services/PromotionCampaign/PromotionCampaign.service";
import { TIME } from "../../../services/date.service";


export const useCampaigns = (filters = {}) => {
  return useQuery({
    queryKey: ['promotionCampaigns',"search", filters],
    queryFn: () => getPromotionCampaigns(filters),
    
  });
};

export function useCampaignsReload() {
    const queryClient = useQueryClient();

    const reload = useCallback(() => {
        return queryClient.invalidateQueries(['promotionCampaigns']);
    }, [queryClient]);
    return reload;
}

  // Custom hook to get campaign by id from campaigns array
export function useCampaignById(campaignId,campaigns = null) {

   const {data,isFetching,isLoading} =  useQuery({
    queryKey: ['promotionCampaigns', campaignId],
    queryFn: () => getPromotionCampaign(campaignId),
    staleTime: TIME.MINUTE_IN_MS * 5, 
    placeholderData : keepPreviousData
  });

  const backfill =  useMemo(() => {
    if (!campaigns || !campaignId) return undefined;
    return campaigns.find(c => c.id === campaignId);
  }, [campaigns, campaignId]);



  const result = useMemo(() => {
    return {
        data: data || backfill,
        isFetching,
        isLoading,
        isError: !data && !backfill,
    }
  },[data, backfill, isFetching, isLoading]);

  return result;
}
